import api from '@/utils/api';
import { getSigV4HeadersForGet, transitionExpiredToken } from '@/utils/cognito';
import { insertServiceIdInApiUrlSync } from '@/utils/common';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import useCommonApiErrorHandling from '@/hooks/useCommonApiErrorHandling';
import useSetLoading from '@/hooks/useSetLoading';
import { Response } from '@/types/api/mypage/services/payment/restriction/option';

/**
 * 「支払情報：規制情報（オプション）」の処理を実施する
 */
const useApiOption = () => {
  const { startLoading, finishLoading } = useSetLoading();
  const { commonErrorHandling, commonResponseCodeHandling } = useCommonApiErrorHandling();

  /**
   * 規制情報（オプション）取得を実施する
   * @param serviceId サービスID
   * @returns 取得結果
   */
  const get = async ({ serviceId }: { serviceId: string }): Promise<AxiosResponse<Response>> => {
    // 支払規制情報はサービス単位で異なるため、明示 serviceId でURLを組み立てる。
    const url = insertServiceIdInApiUrlSync(
      ApiUrl.Read.Services.Payment.RESTRICTION_OPTION,
      serviceId
    );
    try {
      startLoading(url);
      const headers = await getSigV4HeadersForGet(url);
      const response = await api.get(url, headers);
      const { isError } = commonResponseCodeHandling({
        responseCode: response.data.response_code,
      });
      if (isError) {
        // 画面で通常結果として扱わせないため、例外に変換して上位フローを止める。
        throw new Error('データの取得に失敗しました');
      }
      return response;
    } catch (error: any) {
      if (!transitionExpiredToken(error)) {
        // トークン切れ以外は共通エラーハンドリングへ委譲する。
        commonErrorHandling({ error });
      }
      throw error;
    } finally {
      finishLoading(url);
    }
  };
  return { get };
};

export default useApiOption;
